import type { SyntheticEvent } from 'react';
import React, { useCallback } from 'react';

import { Modal, Typography } from 'antd';

interface IProps {
  hasActive: boolean;
  closeModal?: (...args: any[]) => any;

  title?: string;
  subTitle?: string | JSX.Element;

  hasButtons?: boolean;
  hideButtonOk?: boolean;

  handleClickOk?: (...args: any[]) => any;
  textButtonOk?: string;
  textButtonCancel?: string;

  loading?: boolean;

  children: any;
  style?: any;
}

const MyModal: React.FC<IProps> = ({
  hasActive,
  closeModal,
  title,
  subTitle,
  children,
  hasButtons,
  hideButtonOk,
  handleClickOk,
  textButtonOk,
  textButtonCancel,
  loading
}) => {
  const onClose = useCallback(
    (ev: SyntheticEvent) => {
      if (loading) {
        return;
      }

      closeModal(ev);
    },
    [loading, closeModal]
  );

  if (!hasActive) {
    return null;
  }

  return (
    <Modal
      open
      onCancel={onClose as any}
      onOk={handleClickOk as any}
      okText={textButtonOk || 'Confirmar'}
      cancelText={textButtonCancel || 'Cancelar'}
      confirmLoading={loading}
      cancelButtonProps={{ disabled: loading, type: 'text' }}
      title={
        title ? (
          <div className='flex flex-col gap-1'>
            <span>{title}</span>
            {subTitle && <Typography.Text type='secondary'>{subTitle}</Typography.Text>}
          </div>
        ) : undefined
      }
      footer={hasButtons ? (hideButtonOk ? (_, { CancelBtn }) => <CancelBtn /> : undefined) : null}
    >
      {children}
    </Modal>
  );
};

export default MyModal;
